'use strict';

angular.module('shiftTraderApp')
  .factory('OrganizationMessages', function (ServerUrls, $http, $injector, Session, TimeService, $q) {

    //OrganizationMessages model constructor
    var OrganizationMessage = function(values) {
      var M = {};

      angular.extend(M, values);
      M.expires_at = moment.utc(M.expires_at).tz(Session.getTimezone());
      M._expires_at_unix = M.expires_at.unix();
      M.created_at = moment.utc(M.created_at).tz(Session.getTimezone());
      M._created_at_unix = M.created_at.unix();

      M.$calculateAcknowledgmentStats = function() {
        M._numActiveAcked = _.where(M.organization_message_responses, function(omr) {
          return omr.active && omr.$isAcknowledged();
        }).length;
        M._numAcked = _.where(M.organization_message_responses, function(omr) {return omr.$isAcknowledged()}).length;
        M._numRecipients = M.organization_message_responses.length;
        M._numActiveRecipients = _.where(M.organization_message_responses, {active: true}).length;
      };

      if (_.has(values, 'organization_message_responses')) {
        var OMR = $injector.get('OrganizationMessageResponses');
        M.organization_message_responses = _.map(values.organization_message_responses, OMR.initWithData);
        M.$calculateAcknowledgmentStats();
      }

      M._discovered_links = linkify.find(M.content);
      M.content_mod = linkifyStr(M.content, {
        linkClass: 'organization_message_embedded_link omid-' + M.id,
        target: '_blank'
      }).replace(/\n/g, '<br>');

      M.$responseByUser = function(user_id) {
        return _.find(M.organization_message_responses, {user_id: user_id, active: true});
      };

      M.$isExpired = function() {
        return TimeService.getNowInStoreTime().isAfter(M.expires_at);
      };

      return M;
    };

    var OrganizationMessages = {};

    OrganizationMessages.getCurrentOrganizationMessages = function (org_id) {
      return $http.get(ServerUrls.current.railsApi + 'organization_messages', {
        params: {
          organization_id: org_id
        }
      })
        .then(function(response) {
          return _.map(response.data, function(orgMessage) {
            return new OrganizationMessage(orgMessage);
          });
        }, function(response) {
          console.log('OrganizationMessages fetch failed');
          return $q.reject(response);
        });
    };

    OrganizationMessages.getOrganizationMessagesSince = function (org_id, dtString) {
      return $http.get(ServerUrls.current.railsApi + 'organization_messages',
        {
          params: {
            start_date: dtString,
            organization_id: org_id
          }
        })
        .then(function (response) {
          return _.map(response.data, function(orgMessage) {
            return new OrganizationMessage(orgMessage);
          });
        }, function(response) {
          console.log('OrganizationMessages fetch failed');
          return $q.reject(response);
        });
    };

    OrganizationMessages.getMessageById = function (messageId) {
      return $http.get(ServerUrls.current.railsApi + 'organization_messages/' + messageId)
        .then(function(response) {
          return new OrganizationMessage(response.data);
        }, function(response) {
          console.log('OrganizationMessages fetch failed');
          return $q.reject(response);
        });
    };

    OrganizationMessages.create = function(data) {
      // data must have: organization_id, expires_at (as an iso8601 date string),
      //                 content (the text), distribution_rules (as a json object)

      return $http.post(ServerUrls.current.railsApi + 'organization_messages', data)
        .then(function(response) {
          return new OrganizationMessage(response.data);
        }, function(response) {
          console.log('OrganizationMessages create failed');
          return $q.reject(response);
        });
    };

    OrganizationMessages.initWithData = function(data) {
      return new OrganizationMessage(data);
    };

    return OrganizationMessages;
  });
